module.exports = __webpack_public_path__ + "static/img/sub_page_banner_8.0b31b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_8.jpg
// module id = hIzX
// module chunks = 0